import styled from 'styled-components';

export const SliderBarList = styled.div`
  margin-top: ${({ theme }) => theme.spacing.x16};
`;
export const SliderBarListItem = styled.div<{ $isActive?: boolean }>`
  padding: ${({ theme }) => `${theme.spacing.x3} 0`};
  margin: ${({ theme }) => `${theme.spacing.x1} 0`};
  color: ${({ theme, $isActive }) => ($isActive ? `${theme.palette.white}` : `${theme.palette.darkGray}`)};
  cursor: pointer;
`;
export const SliderBarListItemSpan = styled.span<{ $active?: boolean }>`
  color: ${({ theme, $active }) => ($active ? theme.palette.white : theme.palette.gray80)};
  margin-inline-start: ${({ theme }) => `${theme.spacing.inside.x8}`};
`;
export const SliderBarListItemSvg = styled.div<{ $active?: boolean }>`
  color: ${({ theme, $active }) => ($active ? theme.palette.white : theme.palette.gray80)};
  font-size: ${({ theme }) => `${theme.fs.xxxl}`};
  line-height: 0;
`;
export const SliderBarListItemAction = styled.div`
  color: ${({ theme }) => `${theme.palette.white}`};
`;
